import { s, x } from './index-BvoALBv3.js';

/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });

/**
 * @class TritonXUserSession
 * @extends LitElement
 * @description Custom Element for handling Triton x user session
 */
class TritonXUserSession extends s {
  static properties = {
    openModal: { type: Boolean, state: true },
  };

  /** @type {Boolean} */
  openModal = false;

  /** @type {String | null} */
  domain = this.getAttribute('domain') || null;

  /** @type {String | null} */
  hmac = this.getAttribute('hmac') || null;

  /** @type {String | null} */
  endpoint = this.getAttribute('endpoint') || null;

  /** @type {String | null} */
  path = this.getAttribute('path') || null;

  /** @type {String | null} */
  salt = this.getAttribute('salt') || null;

  /** @type {String | null} */
  userSessionId = this.getAttribute('user-session-id') || null;

  /** @type {String | null} */
  userId = this.getAttribute('user-id') || null;

  /** @type {String | null} */
  shopifyCustomerId = this.getAttribute('shopify-customer-id') || null;

  constructor() {
    super();

    // Check if all required attributes are set, if not remove the cookie
    if (
      !this.endpoint ||
      !this.path ||
      !this.domain ||
      !this.hmac ||
      !this.salt ||
      !this.userSessionId ||
      !this.userId ||
      !this.shopifyCustomerId
    ) {
      this.endUserSession();
      return;
    }
    this.getUserSession();
  }

  async getUserSession() {
    // Set default state
    let sessionActive = false;

    // Check the user session or extend the user session by calling the endpoint again by default
    let { isSessionActive = false } = await this.fetchUserSession();

    // Set the user session cookie when isSessionActive is true
    if (isSessionActive === true) {
      // Set the new cookie with the new time
      const expiresInFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
      api.set('triton-x-user-is-session-active', JSON.stringify(sessionActive), {
        expires: expiresInFifteenMinutes,
      });

      if (!this.cookieInterval) {
        // We are extending the session every minute for the user
        this.cookieInterval = setInterval(async () => {
          await this.getUserSession();
        }, 60000);
      }
      return;
    }

    // Clear cookies,interval and redirect to the logout
    if (this.cookieInterval) {
      clearInterval(this.cookieInterval);
    }
    this.endUserSession();
  }

  async fetchUserSession() {
    console.log('> fetchUserSession');
    try {
      let options = {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'X-Shopify-Shop-Domain': this.domain,
          'X-Shopify-HMAC-Sha256': this.hmac,
        },
      };
      const response = await fetch(
        `${this.endpoint}${this.path}?userSessionId=${this.userSessionId}&userId=${this.userId}&customerId=${this.shopifyCustomerId}&salt=${this.salt}`,
        options
      );

      if (!response.ok) {
        throw new Error('Error occurred! User session could not be fetched.');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      console.log(error);
    }
  }

  endUserSession() {
    api.remove('triton-x-user-is-session-active');
    this.openModal = true;
  }

  // Add this to set up focus trap when modal opens
  updated() {
    if (this.openModal === true) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => trapFocus(this));
    } else {
      removeTrapFocus(this);
    }
  }

  render() {
    return this.openModal
      ? x`
          <div class="fixed inset-0 z-modal-backdrop block h-full w-full bg-black/50"></div>
          <div class="fixed inset-0 z-modal h-full w-full overflow-auto px-6 py-12">
            <div
              class="modal-content mx-auto w-full max-w-[400px] space-y-4 rounded bg-white p-8"
              tabindex="-1"
            >
              <p class="block text-2xl font-bold">${triton_x.session_expired.title}</p>
              <p>${triton_x.session_expired.description}</p>
              <div class="flex flex-wrap gap-2">
                <button
                  type="button"
                  class="button button--blue"
                  @click=${() => {
                    window.location.href = routes.account_logout_url;
                  }}
                >
                  ${triton_x.session_expired.button_label}
                </button>
              </div>
            </div>
          </div>
        `
      : null;
  }

  createRenderRoot() {
    return this;
  }
}

customElements.define('triton-x-user-session', TritonXUserSession);

export { TritonXUserSession as default };
